import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  HeaderTypography,
  StyledTableContainer,
  DataTypography,
} from "./cart-table.styled";
import amountToFixed from "@/helper/amountToFixed";

const money = (amount) => `RD$ ${amountToFixed(amount, 2)}`;

export default function CartTable({ selectedProducts }) {
  return (
    <StyledTableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <HeaderTypography>Cantidad</HeaderTypography>
            </TableCell>
            <TableCell>
              <HeaderTypography>Products</HeaderTypography>
            </TableCell>
            <TableCell>
              <HeaderTypography style={{ textAlign: "center" }}>
                Subtotal Pre-descuento
              </HeaderTypography>
            </TableCell>
            <TableCell>
              <HeaderTypography style={{ textAlign: "center" }}>
                Descuento
              </HeaderTypography>
            </TableCell>
            <TableCell align="left">
              <HeaderTypography>Subtotal</HeaderTypography>
            </TableCell>
            <TableCell align="left">
              <HeaderTypography>Impuesto</HeaderTypography>
            </TableCell>
            <TableCell align="left">
              <HeaderTypography>10% Servicio</HeaderTypography>
            </TableCell>
            <TableCell align="left">
              <HeaderTypography>Efectivo / Tarjeta</HeaderTypography>
            </TableCell>
            <TableCell align="left">
              <HeaderTypography>Beneficios</HeaderTypography>
            </TableCell>
            <TableCell align="left">
              <HeaderTypography>Total línea</HeaderTypography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedProducts.map((row) => {
            const totals = row.checkoutTotals;
            const taxes = totals.taxesList.filter(({ id }) => id !== "tax10");
            return (
              <TableRow
                key={`${row.sourceIndex}-${row.cartIndex}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.quantity}
                </TableCell>
                <TableCell align="left">
                  <DataTypography>{row.name}</DataTypography>
                </TableCell>
                <TableCell align="left">
                  <DataTypography>{money(totals.grossSubtotal)}</DataTypography>
                </TableCell>
                <TableCell align="left">
                  <DataTypography>
                    {money(totals.totalPromotion)}
                  </DataTypography>
                </TableCell>
                <TableCell align="left">
                  <DataTypography>
                    {money(totals.subtotalAfterPromotions)}
                  </DataTypography>
                </TableCell>
                <TableCell align="left">
                  {taxes.length === 0 ? (
                    <DataTypography>{money(0)}</DataTypography>
                  ) : (
                    taxes.map((tax) => (
                      <DataTypography
                        key={tax.id}
                      >{`${tax.name} ${money(tax.amount)}`}</DataTypography>
                    ))
                  )}
                </TableCell>
                <TableCell align="left">
                  <DataTypography>{money(totals.serviceTax)}</DataTypography>
                </TableCell>
                <TableCell align="left">
                  <DataTypography>
                    {money(row.payment.externalAmount)}
                  </DataTypography>
                </TableCell>
                <TableCell align="left">
                  <DataTypography>{money(totals.totalBenefits)}</DataTypography>
                </TableCell>
                <TableCell align="left">
                  <DataTypography>{money(totals.amountDue)}</DataTypography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
}
